import { Box, styled } from '@ltvco/refresh-lib/theme';

/**
 * Container for pagination loading overlay
 */
export const PaginationOverlayContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: `${theme.palette.common.white}D9`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10,
  backdropFilter: 'blur(2px)',
}));

/**
 * Styles for pagination overlay card
 */
export const paginationOverlayCardStyles = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  gap: 2,
  backgroundColor: 'common.white',
  borderRadius: 2,
  p: 3,
  boxShadow: 4,
};
